import AddIcon from "@mui/icons-material/Add";
import HomeRepairServiceOutlinedIcon from "@mui/icons-material/HomeRepairServiceOutlined";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import clsx from "clsx";
import React, { FC, useState } from "react";
import Cookies from "universal-cookie";
import { login, logout } from "../helpers/auth";
import { generateStyles } from "../helpers/utils";
import {
  EButtonTypes,
  IComponentStyles,
  IMenuButton,
  TrustedWidgetConfig,
} from "../types";
import styles from "./CustomButton.module.css";

interface ICustomButtonProps {
  config: TrustedWidgetConfig;
  content: IMenuButton;
  customStyles: IComponentStyles;
  icon?: React.ReactNode | string;
}

export const CustomButton: FC<ICustomButtonProps> = ({
  config,
  content,
  customStyles,
  icon,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const globalStyles = generateStyles(config);
  const { background, text, hover, position } = customStyles;
  const url = window.location.origin;
  const cookies = new Cookies();
  const token = cookies.get("accessToken");

  const fetchOrgData = async (link: string) => {
    window.location.href = `${url}/app/${config?.appId}/org`;
    const response = await fetch(link, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.ok) {
      const data = await response.json();
      window.location.href = `${url}/app/${data.orgId}/settings`;
    }
  };

  const handleNavigate = async (link: string, type?: string) => {
    switch (type) {
      case "login":
        login(config);
        break;
      case "logout":
        logout();
        break;
      case "add_sso":
        fetchOrgData(link);
        break;
      default:
        window.location.href = link;
    }
  };

  const getIcon = (type?: string) => {
    if (typeof icon === "string") {
      return (
        <img src={icon} className={styles.buttonIcon} alt={content.text} />
      );
    } else if (React.isValidElement(icon)) {
      return icon;
    }

    switch (type) {
      case EButtonTypes.logout:
        return <LogoutIcon className={styles.buttonIcon} />;
      case EButtonTypes.personal:
        return <PersonIcon className={styles.buttonIcon} />;
      case EButtonTypes.system:
      case EButtonTypes.org:
        return <HomeWorkOutlinedIcon className={styles.buttonIcon} />;
      case EButtonTypes.sso:
        return (
          <AddIcon className={clsx(styles.buttonIcon, styles.addIconWrapper)} />
        );
      case EButtonTypes.admin:
        return <HomeRepairServiceOutlinedIcon className={styles.buttonIcon} />;
      default:
        return;
    }
  };

  return (
    <button
      onClick={() => handleNavigate(content.link, content.type)}
      className={clsx(
        styles.button,
        hover ? "" : styles.buttonHover,
        position === "center" && styles.buttonCenter,
        content.type === "logout" &&
          background === globalStyles.primaryButton.background
          ? styles.logoutButton
          : ""
      )}
      style={{
        color: text,
        backgroundColor: isHovered && hover ? hover : background,
        borderRadius: globalStyles.borderRadius,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {getIcon(content.type)}
      {content.text}
    </button>
  );
};
